export const getters = {
    list: state => state.list,
    flat: state => state.flat,
    plan_img: state => state.plan_img,
    model: state => state.model,
    areas: state => state.areas,
};